<template>
  <div>
    <b-card v-if="!loading">
      <h2 class="text-center">{{ $t("warehouse.use-scanner") }}</h2>

      <div class="d-flex justify-content-center">
        <b-img
          :src="require('@/assets/images/banner/barcodeScanner.gif')"
          class="modify-img"
          width="200"
          height="200"
          alt=" "
        />
      </div>
      <b-col lg="4">
        <b-form-group :label="$t('warehouse.barcode')" label-for="barcode">
          <b-form-input
            ref="inputRef"
            id="barcode"
            v-model="barcode"
            @change="changeBarcode"
            :placeholder="$t('warehouse.barcode')"
          />
        </b-form-group>
        <barcode :value="barcode" />
      </b-col>
    </b-card>
    <b-card v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BImg,
} from "bootstrap-vue";
import VueBarcode from "vue-barcode";

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BImg,
    barcode: VueBarcode,
  },

  data() {
    return {
      barcode: "",
      loading: false,
    };
  },

  mounted() {
    this.$refs.inputRef.focus();
  },
  methods: {
    changeBarcode() {
      this.$emit("barcode", this.barcode);
      this.$refs.inputRef.focus();
      setTimeout(() => {
        this.barcode = "";
      }, 100);
    },
  },
};
</script>

<style>
.hidden-input {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
</style>
